import { Component, ViewEncapsulation, inject, input, output } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentService } from '@ap/content';
import { ApListItemComponent } from '@ap/list-item';

import { ProfileMenu, ProfileMenuItem } from '../header.model';

import content from './profile-menu.content.json';

/**
 * @ngdoc component
 * @name ProfileMenu
 */
@Component({
    selector: 'ap-profile-menu',
    templateUrl: './profile-menu.component.html',
    styleUrls: ['./profile-menu.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApButtonComponent, ApListItemComponent]
})
export class ApProfileMenuComponent {
    private readonly contentService = inject(ApContentService);

    /**
     * Profile menu with user data
     */
    public readonly profileMenu = input<ProfileMenu>();

    /**
     * Eventemitter that is emitted on click, keyboard enter and keyboard space
     * Emits clicked profile menu item
     */
    public readonly itemClicked = output<ProfileMenuItem>();

    /**
     * Emits event to logout
     */
    public readonly loginLogout = output<boolean>();

    constructor() {
        this.contentService.addContentItems(content);
    }

    /**
     * Get correct greeting based on time of day
     */
    public get greeting(): string {
        const currentHour = new Date().getHours();

        switch (true) {
            case currentHour < 6:
                return this.contentService.get('profile.greeting-night');
            case currentHour < 12:
                return this.contentService.get('profile.greeting-morning');
            case currentHour < 18:
                return this.contentService.get('profile.greeting-afternoon');
            default:
                return this.contentService.get('profile.greeting-evening');
        }
    }
}
